// extracted by mini-css-extract-plugin
export default {"page":"About_page__-44+w","hero":"About_hero__aF4Bk","eyebrow":"About_eyebrow__c9RcW","story":"About_story__eiU3L","values":"About_values__kDsbm"};